import { render, staticRenderFns } from "./VideoShow.vue?vue&type=template&id=b0396616&"
import script from "./VideoShow.vue?vue&type=script&lang=ts&"
export * from "./VideoShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports